import 'whatwg-fetch';
import { configureFetch, fetchFile, fetchJSON } from './refresh-fetch';
import { apiBaseURL } from '../config';

const encodeValue = value => {
  if (typeof value === 'object') {
    return encodeURIComponent(JSON.stringify(value));
  }

  return encodeURIComponent(value);
};

const formatQueryParams = params =>
  Object.keys(params)
    .map(k => `${encodeURIComponent(k)}=${encodeValue(params[k])}`)
    .join('&');

const fetchWithToken = (url, options = {}) => {
  const base = options.apiBaseURL || apiBaseURL;

  let optionsWithToken = options;

  if (optionsWithToken && optionsWithToken.body) {
    optionsWithToken.body = JSON.stringify(optionsWithToken.body);
  }

  if (optionsWithToken && optionsWithToken.params) {
    const params = formatQueryParams(optionsWithToken.params);
    url = `${url}?${params}`;
  }

  if (!options || options.responseType !== 'blob') {
    return fetchJSON(base + url, optionsWithToken);
  }
  return fetchFile(base + url, optionsWithToken);
};

const request = configureFetch({
  fetch: fetchWithToken,
});

export default request;
